"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarClock } from "lucide-react";
import AnimatedHamburger from "./AnimatedHamburger";
import { useCalBooking } from "@/providers/booking/CalBookingProvider";
interface DesktopActionsProps {
  visible: boolean;
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  onScrollTop: () => void;
}

// The md+ stack: three circular pucks parked in the bottom-right corner. Not a
// bar — on a mouse-driven screen there is no thumb reach to respect, so the
// controls stay out of the content instead of spanning it.
const DesktopActions = t0 => {
  const $ = _c(12);
  const {
    visible,
    isMenuOpen,
    onToggleMenu,
    onScrollTop
  } = t0;
  const [isLarge, setIsLarge] = useState(false);
  const {
    enabled: calEnabled,
    goToBooking
  } = useCalBooking();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = () => setIsLarge(window.innerWidth > 1024);
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== calEnabled || $[3] !== goToBooking || $[4] !== isLarge || $[5] !== isMenuOpen || $[6] !== onScrollTop || $[7] !== onToggleMenu || $[8] !== visible) {
    t3 = visible && <motion.div key="desktop-actions" initial={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: "easeOut"
    }} className="fixed bottom-10 right-10 z-500 hidden items-center gap-2 md:flex">{calEnabled ? <button type="button" onClick={goToBooking} aria-label="Book a session" title="Book Now" className="cursor-pointer rounded-full border-2 border-primary bg-black p-2 shadow-2xl transition-all hover:scale-110 active:scale-90"><CalendarClock size={isLarge ? 24 : 22} className="text-primary" /></button> : <Link href="/contact" aria-label="Book a session" title="Book Now" className="cursor-pointer rounded-full border-2 border-primary bg-black p-2 shadow-2xl transition-all hover:scale-110 active:scale-90"><CalendarClock size={isLarge ? 24 : 22} className="text-primary" /></Link>}<button type="button" onClick={onScrollTop} aria-label="Scroll to top" className="flex cursor-pointer items-center justify-center rounded-full border-2 border-black bg-primary transition-all hover:scale-110 active:scale-90" style={{
        width: "45px",
        height: "45px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
      }}><Image src="/up-arrow.png" alt="scroll to top" width={isLarge ? 24 : 20} height={isLarge ? 24 : 20} /></button><div className="bg-black p-2 rounded-full border-2 border-primary shadow-2xl transition-all hover:scale-110 active:scale-90 cursor-pointer"><AnimatedHamburger isOpen={isMenuOpen} onClick={onToggleMenu} color="#b2d127" openColor="#b2d127" size={isLarge ? 24 : 22} lineHeight={2} /></div></motion.div>;
    $[2] = calEnabled;
    $[3] = goToBooking;
    $[4] = isLarge;
    $[5] = isMenuOpen;
    $[6] = onScrollTop;
    $[7] = onToggleMenu;
    $[8] = visible;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default DesktopActions;